import {
  firstNameType,
  lastNameType,
  addressType,
  zipType,
  cityType
} from './shippingFieldsTypes'

const firstName: firstNameType = {
  id: 'firstName',
  type: 'text',
  maxLength: '30',
  size: '50',
  required: true,
  validateMethod: (firstName: string): boolean => {
    return firstName.length > 1
  }
}

const lastName: lastNameType = {
  id: 'lastName',
  type: 'text',
  maxLength: '30',
  size: '50',
  required: true,
  validateMethod: (lastName: string): boolean => {
    return lastName.length > 1
  }
}

const address1: addressType = {
  id: 'address1',
  type: 'text',
  size: '100',
  required: true,
  validateMethod: (address1): boolean => {
    return address1 !== ''
  }
}

const address2: addressType = {
  id: 'address2',
  type: 'text',
  size: '100',
  required: false
  // validateMethod: (address1): boolean => {
  //   return address1 !== ''
  // }
}

const zip: zipType = {
  id: 'zip',
  type: 'tel',
  pattern: '[0-9]*',
  maxLength: '8',
  size: '50',
  required: true,
  validateMethod: (zip): boolean => {
    return zip.length >= 5
  }
}

const city: cityType = {
  id: 'city',
  type: 'text',
  maxLength: '30',
  size: '50',
  required: true,
  validateMethod: (city): boolean => {
    return city.length >= 3
  }
}

/* Country speicfic properties  */

const sweden: object = (): Array<object> => {
  const fields = [
    firstName,
    lastName,
    address1,
    address2,
    zip,
    city
  ]
  return fields
}

const finland: object = () => {
  // filter out based on the passed in fields and only returned the matching ones
  const fields = [
    firstName,
    lastName,
    address1,
    address2,
    zip,
    city
  ]
  return fields
}

export default {
  sweden,
  finland
}
